import { isUrl } from "@shared/urlUtils";

// Re-exported so existing client imports keep working; the implementation is
// shared with the server (see src/shared/urlUtils.ts).
export { isUrl };

export function getSubDomain() {
  return window.location.host.split(".")[0];
}

export function isProduction() {
  const nonProductionPrefixes = ["stage", "dev", "localhost", "127.0.0.1"];
  return !nonProductionPrefixes.some((v) => getSubDomain().includes(v));
}
